<!-- eslint-disable vue/valid-v-for -->
<template>
  <div class="box" :style="cssVars" v-html="appLoginAgreement"></div>
</template>

<script>
import { isJSONString, setFavicon } from '@/utils/utils';
import { getLogo } from '@/utils/intConfiguration';
import { getUiFitment } from '@/utils/accessResources';

export default {
  name: 'Privacy',
  components: {},
  data() {
    return {
      logoUi: getLogo(),
      appLoginAgreement: '',
    };
  },
  computed: {
    cssVars() {
      return {
        '--themeColor': this.logoUi.themeColor,
      };
    },
  },
  created() {},
  mounted() {
    try {
      if (isJSONString('uiInfo')) {
        const uiInfo = JSON.parse(localStorage.getItem('uiInfo'));
        this.appLoginAgreement = uiInfo.appLoginAgreement.replace(
          /\[《(.*?)》\]\((.*?)\)/g,
          ' 《<a style="color:#4D4DFF;" href="$2">$1</a>》 ',
        );
      }
    } catch (error) {}
    console.log('uiInfo', uiInfo);
    getUiFitment()
  },
};
</script>
<style scoped>
a {
  color: var(--themeColor) !important;
  cursor: pointer;
}

.box {
  padding: 12px 0;
  width: 100%;
  text-align: center;
  color: #a9a8a9;
}
</style>
